import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './Blogs.css';
import axios from "../../utils/axiosInstance";

class Blogs extends Component {

  constructor(props) {
    super(props);
    this.state = {
      blogs: [],
      loading: true,
      error: null
    };
  }

  componentDidMount() {
    this.fetchBlogs();
  }

  fetchBlogs = async () => {
    try {
      this.setState({ loading: true, error: null });

      // Assuming your axiosInstance is configured with the base API URL
      const response = await axios.get('/get_blogs');
      const result = response.data;

      if (result.status === 'success' && result.data) {
        this.setState({ blogs: result.data, loading: false });
      } else {
        this.setState({ error: 'Failed to retrieve blogs.', loading: false });
      }
    } catch (error) {
      console.error("Error fetching blogs:", error);
      this.setState({ error: 'Network error occurred while fetching blogs.', loading: false });
    }
  };

  formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  render() {
    
    const { blogs, loading, error } = this.state;
    const baseUrl = axios.defaults.baseURL.replace("/api", "");

    return (
      <section className="travel-blogs-section container py-5">

        {/* Header Section */}
        <div className="text-center mb-5">
          <h2 className="blog-main-title">Travel Smarter with Bookly</h2>
          <div className="blog-subtitle-wrapper">
            <span className="blog-subtitle">best choice?</span>
            <svg className="blog-subtitle-underline" viewBox="0 0 150 15" xmlns="http://www.w3.org/2000/svg">
              <path d="M5,10 Q75,2 145,12" fill="none" stroke="#0047CC" strokeWidth="2.5" strokeLinecap="round" />
            </svg>
          </div>
        </div>

        {/* Loading and Error States */}
        {loading && (
          <div className="text-center py-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        )}

        {error && (
          <div className="alert alert-danger text-center" role="alert">
            {error}
          </div>
        )}

        {/* Blog Cards Grid */}
        {!loading && !error && (
          <div className="row g-4">
            {blogs.map((blog) => (
              <div className="col-lg-4 col-md-6" key={blog.id}>
                <div className="blog-card">

                  {/* Image & Badge Wrapper */}
                  <div className="blog-image-wrapper">
                    <img
                      src={`${baseUrl}/uploads/blogs/${blog.blog_img}`}
                      alt={blog.blog_title}
                      className="img-fluid blog-image"
                    />
                    <span className="blog-badge">
                      {blog.admin_id ? blog.admin_id.toUpperCase() : 'BLOG'}
                    </span>
                  </div>

                  {/* Text Content */}
                  <div className="blog-content mt-3">
                    <div className="blog-meta">
                      {this.formatDate(blog.blog_date)} &middot; 5 min read
                    </div>
                    <h4 className="blog-card-title">{blog.blog_title}</h4>
                    <a href={`#blog-${blog.id}`} className="read-more-link d-inline-flex align-items-center gap-1">
                      Read More <i className="bi bi-arrow-up-right"></i>
                    </a>
                  </div>

                </div>
              </div>
            ))}
          </div>
        )}

        {/* Bottom Button */}
        <div className="text-center mt-5">
          <button className="btn-view-all-blogs d-inline-flex align-items-center gap-2">
            View all blogs <i className="bi bi-arrow-up-right"></i>
          </button>
        </div>

      </section>
    );
  }
}

export default Blogs;
